import { Link } from "react-router-dom";
import { footerLogo } from "@/mocks/ppcare";

const footerNav = [
  { label: "Home", href: "/", isRoute: true },
  { label: "About", href: "#about", isRoute: false },
  { label: "Services", href: "#services", isRoute: false },
  { label: "Providers", href: "#providers", isRoute: false },
  { label: "Resources", href: "#resources", isRoute: false },
  { label: "Locations", href: "#locations", isRoute: false },
  { label: "Contact", href: "#contact", isRoute: false },
];

export default function Footer() {
  return (
    <footer id="footer" className="relative overflow-hidden bg-primary-950 text-background-200">
      {/* Decorative circles */}
      <img
        src="https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648ca67f3cfca603b7277dea_Footer%20Circle%20Decor.webp"
        alt=""
        className="pointer-events-none absolute -left-24 top-10 hidden w-72 opacity-20 lg:block"
      />
      <img
        src="https://cdn.prod.website-files.com/64887ec78153e4fc4e1e7914/648ca75d4b0b9e71da65feda_Top%20Footer%20Circle%20Decor.webp"
        alt=""
        className="pointer-events-none absolute -right-24 top-0 hidden w-80 opacity-20 lg:block"
      />

      <div className="container relative z-10 py-14 md:py-20">
        <div className="flex flex-col items-center gap-8 text-center">
          <Link to="/">
            <img
              src={footerLogo}
              alt="Personal Physician Care"
              className="h-20 w-auto object-contain md:h-28"
            />
          </Link>
        </div>

        <nav className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 border-y border-background-50/10 py-6">
          {footerNav.map((link) =>
            link.isRoute ? (
              <Link
                key={link.label}
                to={link.href}
                className="whitespace-nowrap text-sm font-medium text-background-200 transition-colors hover:text-accent-400"
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.label}
                href={link.href}
                className="whitespace-nowrap text-sm font-medium text-background-200 transition-colors hover:text-accent-400"
              >
                {link.label}
              </a>
            )
          )}
        </nav>

        <div className="mt-10 flex flex-col items-start gap-3">
          <div className="flex items-start gap-3">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center text-accent-400">
              <i className="ri-map-pin-2-fill text-xl" />
            </span>
            <div>
              <p className="text-sm font-semibold text-background-50">Personal Physician Care:</p>
              <a
                href="#locations"
                className="text-sm text-background-300 underline-offset-4 transition-colors hover:text-accent-400 hover:underline"
              >
                Directions to Nearest Personal Physician Care Location
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 space-y-4 border-t border-background-50/10 pt-8 text-xs leading-relaxed text-background-400">
          <p>
            All of the information on this website is for informational purpose only. Patients and
            consumers should review the information carefully with their professional health care
            provider. The information is not intended to replace medical advice offered by
            physicians.
          </p>
          <p>
            By using this website and sending us your information you are giving us permission to
            contact you by electronic and non-electronic means. We also track the conversions and
            collect user data to improve marketing. If you are vision-impaired or have some other
            impairment covered by the Americans with Disabilities Act or a similar law, and you wish
            to discuss potential accommodations related to using this website, please contact us.
          </p>
        </div>

        <p className="mt-8 text-center text-xs text-background-500">
          © {new Date().getFullYear()} Personal Physician Care, P.A. All rights reserved.
        </p>
      </div>
    </footer>
  );
}